import { useMemo } from 'react';
import { useCountSegmentRecipients } from '@frontend/api-bulk-messaging';
import { useDebouncedValue } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

export const useCountFilterRecipients = () => {
  const { campaignId, filters } = useAudienceTray();

  const debouncedFilters = useDebouncedValue(filters, 1500);

  const countRequest = useMemo(
    () => ({
      campaignId,
      segment: {
        segmentId: '',
        filterOptions: debouncedFilters,
      },
    }),
    [campaignId, debouncedFilters]
  );

  const { data: filterRecipientsCount, isError } = useCountSegmentRecipients(countRequest, {
    retry: false,
  });

  return {
    filterRecipientsCount,
    isError,
  };
};
